import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class LprReadsFieldsModel extends SnModel {
  @Expose({ name: 'vehicle_make' })
  public vehicleMake: any[];

  @Expose({ name: 'vehicle_model' })
  public vehicleModel: any[];

  @Expose({ name: 'vehicle_color' })
  public vehicleColor: any[];

  @Expose({ name: 'vehicle_year' })
  public vehicleYear: any[];

  @Expose({ name: 'vehicle_body_type' })
  public vehicleBodyType: any[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
